import React from 'react'
import { Nav, Button, Dropdown } from 'tabler-react'
import { NavLink, withRouter } from 'react-router-dom'
import logo from '../../assets/brand_logo.svg'
import avatar from '../../assets/ic_account.png'
import store from '../../shared/store'
import Exchange from '../Home/Exchange'
import modal from '../../components/Modal'
import i18n from '../../shared/i18n'

const NavLinks = () => (
  <div className="space-between mobile-nav">
    <Nav>
      <NavLink className="nav-link" exact to="/dashboard">
        <i className="fe fe-home" />
        {i18n.t('dash-nav-home')}
      </NavLink>
      <NavLink
        className="nav-link"
        RootComponent="a"
        to="/buy?utm_source=dashboard&utm_medium=nav"
        target="_blank">
        <i className="fe fe-shopping-cart" />
        {i18n.t('dash-nav-buy')}
      </NavLink>
      <NavLink className="nav-link" to="/dashboard/vas">
        <i className="fe fe-plus-square" />
        {i18n.t('dash-nav-vas')}
        <span className="tag-new">{i18n.t('dash-nav-promotag')}</span>
      </NavLink>
      <NavLink className="nav-link" to="/dashboard/affiliate">
        <i className="fe fe-credit-card" />
        {i18n.t('dash-nav-aff')}
      </NavLink>
      {/* <NavLink className="nav-link" to="/support" target="_blank">
        <i className="fe fe-life-buoy" />
        帮助中心
      </NavLink> */}
      <NavLink className="nav-link" to="/dashboard/ticket">
        <i className="fe fe-headphones" />
        {i18n.t('dash-nav-support')}
      </NavLink>
    </Nav>
  </div>
)

const NavItems = () => {
  return (
  <Nav.Item type="div" className="d-none d-md-flex">
    <Button
      icon="box"
      className="card-exchange-btn"
      onClick={() => {
        modal(<Exchange />, { title: i18n.t('dash-nav-activecard') })
      }}>
      {i18n.t('dash-nav-activecard')}
    </Button>
    {/* <a
      href="/buy?code=EDUCATION"
      className="edu-badge">
      <i className="ri-coupon-3-fill" />
      <span>{i18n.t('dash-nav-edutip')}</span>
      <i className="ri-arrow-right-s-line" />
    </a> */}
    {/* <a
      href="/buy"
      className="" target='_blank'>
      <i className="ri-shopping-cart-fill" />
      <span> {i18n.t('dash-nav-buy')}</span>
    </a> */}
    <Dropdown
  type="button"
  arrow
  icon="globe"
  triggerContent={store.lang.name}
  itemsObject={store.langs.map(lang => {
    return {
      value: lang.name,
      RootComponent: withRouter(({ history }) => (
        <a
          className='dropdown-item'
          href='#'
          onClick={() => {
            store.dispatch({ type: 'updateLang', payload: lang.id })
          }}>
          {lang.name}
        </a>
      )),
    }
  })}
/>
  </Nav.Item>
  )
}

const userDesc = () => {
  return store.user ? store.user.userDesc : ''
}

export default {
  headerProps: {
    alt: 'Malus',
    href: '/',
    imageURL: logo,
    navItems: <NavItems />,
    accountDropdown: {
      avatarURL: avatar,
      name: store.user
        ? store.user.email || store.user.displayName || store.user.phone
        : 'Unknown',
      description: userDesc(),
      options: [
        { 
          RootComponent: withRouter(({ history }) => (
            <a
              className='dropdown-item'
              href='#'
              onClick={() => {
                history.push('/dashboard/account')
              }}>
              <i class="fe fe-settings dropdown-icon"></i>
              {i18n.t('dash-nav-setting')}
            </a>
          )),
        },
        {
          // icon: 'list',
          // value: i18n.t('dash-nav-orders'),
          RootComponent: withRouter(({ history }) => (
            <a
              className='dropdown-item'
              href='#'
              onClick={() => {
                history.push('/dashboard/order')
              }}>
              <i class="fe fe-list dropdown-icon"></i>
              {i18n.t('dash-nav-orders')}
            </a>
          )),
        },
        { 
          // icon: 'mail', value: i18n.t('dash-nav-emailsubscribe'), to: '/dashboard/subscribe',
          RootComponent: withRouter(({ history }) => (
            <a
              className='dropdown-item'
              href='#'
              onClick={() => {
                history.push('/dashboard/subscribe')
              }}>
              <i class="fe fe-mail dropdown-icon"></i>
              {i18n.t('dash-nav-emailsubscribe')}
            </a>
          )),
        },
        // { icon: 'link', value: '绑定公众号', to: '/dashboard/wechat' },
        { isDivider: true },
        {
          // icon: 'life-buoy',
          // value: i18n.t('dash-nav-tickets'),
          // to: `https://api.getmalus.com/api/loginZendesk?token=${store.user &&
          //   store.user.token}`,
          RootComponent: withRouter(({ history }) => (
            <a
              className='dropdown-item'
              href={`https://api.getmalus.com/api/loginZendesk?token=${store.user && store.user.token}`}
              target='_blank'>
              <i class="fe fe-life-buoy dropdown-icon"></i>
              {i18n.t('dash-nav-tickets')}
            </a>
          )),
        },
        {
          // icon: 'help-circle',
          // value: i18n.t('dash-nav-help'),
          // to: 'https://support.getmalus.com',
          RootComponent: withRouter(({ history }) => (
            <a className='dropdown-item' href='/buy' target='_blank'>
              <i class="fe fe-shopping-cart dropdown-icon"></i>
              {i18n.t('dash-nav-buy')}
            </a>
          )),
        },
        {
          // icon: 'help-circle',
          // value: i18n.t('dash-nav-help'),
          // to: 'https://support.getmalus.com',
          RootComponent: withRouter(({ history }) => (
            <a className='dropdown-item' href='/support' target='_blank'>
              <i class="fe fe-help-circle dropdown-icon"></i>
              {i18n.t('dash-nav-help')}
            </a>
          )),
        },
        {
          // icon: 'download',
          // value: i18n.t('dash-nav-download'),
          // to: '/download',
          RootComponent: withRouter(({ history }) => (
            <a
              className='dropdown-item'
              href='/download'
              target='_blank'>
              <i class="fe fe-download dropdown-icon"></i>
              {i18n.t('dash-nav-download')}
            </a>
          )),
        },
        { isDivider: true },
        {
          // icon: 'log-out',
          // value: i18n.t('dash-nav-logout'),
          // to: '/dashboard/logout',
          RootComponent: withRouter(({ history }) => (
            <a
              className='dropdown-item'
              href='#'
              onClick={() => {
                store.logout()
                window.location.href = '/dashboard/login'
              }}>
              <i class="fe fe-log-out dropdown-icon"></i>
              {i18n.t('dash-nav-logout')}
            </a>
          )),
        },
      ],
    },
  },
  navProps: { children: <NavLinks /> },
}
